import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const CustomButton = styled(Button)`
  padding: 0;
`
